import React from "react"
import cn from "classnames"
import Fieldset from "./Fieldset"
import { toOption } from "./Select"
import styles from "../../styles/scss/components/form/formSystem.module.scss"

const RadioGroup = ({
    name,
    id = name,
    legend,
    options = [],
    value,
    onChange,
    onBlur,
    required,
    help,
    error,
    row,
    className,
}) => (
    <Fieldset
        id={id}
        legend={legend}
        required={required}
        help={help}
        error={error}
        row={row}
        className={className}
    >
        {options.map(toOption).map((o, i) => {
            const optId = `${id}-${i}`
            return (
                <label key={o.value} className={cn(styles.opt)} htmlFor={optId}>
                    <input
                        type="radio"
                        id={optId}
                        name={name}
                        value={o.value}
                        className={styles.radio}
                        checked={String(value) === o.value}
                        onChange={onChange}
                        onBlur={onBlur}
                        required={required}
                        aria-invalid={error ? "true" : undefined}
                    />
                    <span className={styles.optText}>{o.label}</span>
                </label>
            )
        })}
    </Fieldset>
)

export default RadioGroup
